"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
Object.defineProperty(exports, "__esModule", { value: true });
var omi_1 = require("omi");
var css = require("./index.scss");
var ripple_1 = require("@material/ripple");
var icon_button_1 = require("@material/icon-button");
var dom_ready_1 = require("../util/dom-ready");
// @ts-ignore
var util_ts_1 = require("../util.ts");
//@ts-ignore
require("../theme.ts");
var IconButton = /** @class */ (function (_super) {
    __extends(IconButton, _super);
    function IconButton() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    IconButton.prototype.installed = function () {
        var _this = this;
        dom_ready_1.domReady(function () {
            _this.update();
            var root = _this.shadowRoot.querySelector('.mdc-icon-button');
            if (_this.props.ripple) {
                var r = new ripple_1.MDCRipple(root);
                r.unbounded = true;
            }
            if (_this.props.icons || _this.props.imgs || (_this.props.children && _this.props.children[0] && _this.props.children[1])) {
                var toggleButton = new icon_button_1.MDCIconButtonToggle(root);
                toggleButton.listen('MDCIconButtonToggle:change', function (evt) {
                    _this.fire('change', { isOn: evt.detail.isOn });
                });
            }
        });
    };
    IconButton.prototype.render = function (props) {
        if (!props.children) {
            props.children = util_ts_1.htmlToVdom(this.innerHTML);
        }
        //svg
        if (props.children && props.children[0] && props.children[1]) {
            props.children[0].attributes.class = 'mdc-icon-button__icon';
            props.children[1].attributes.class = 'mdc-icon-button__icon mdc-icon-button__icon--on';
            return omi_1.h("button", __assign({ style: "color:" + props.color + ";" }, omi_1.extractClass(props, 'mdc-icon-button material-icons'), util_ts_1.extract(props, ['disabled'])), props.children);
        }
        return (omi_1.h("button", __assign({ style: "color:" + props.color + ";" }, omi_1.extractClass(props, 'mdc-icon-button material-icons'), util_ts_1.extract(props, ['disabled'])), props.icon ? props.icon : (props.icons ? [
            omi_1.h("i", { class: "material-icons mdc-icon-button__icon mdc-icon-button__icon--on" }, props.icons[0]),
            omi_1.h("i", { class: "material-icons mdc-icon-button__icon" }, props.icons[1])
        ] : (props.imgs && [
            omi_1.h("img", { src: props.imgs[0], class: "mdc-icon-button__icon" }),
            omi_1.h("img", { src: props.imgs[1], class: "mdc-icon-button__icon mdc-icon-button__icon--on" })
        ]))));
    };
    IconButton.css = css;
    IconButton.defaultProps = {
        ripple: true
    };
    IconButton.propTypes = {
        ripple: Boolean,
        toggle: Object,
        icons: Object,
        icon: String,
        imgs: Object,
        svg: Object,
        color: String,
        disabled: Boolean
    };
    IconButton = __decorate([
        omi_1.tag('m-icon-button')
    ], IconButton);
    return IconButton;
}(omi_1.WeElement));
exports.default = IconButton;
